// src/utils/adHydrator.js
import { CATEGORIES_DATA } from '../constants/Categories';
import { COMMON_FIELDS, CATEGORY_FORM_SPECS } from '../constants/FormSpecs';

export const hydrateAdData = (aiResult, categoryId, subCategoryId) => {
  const hydratedData = {};

  // 1. Map Special AI Fields to Form Field Names
  // AI uses 'titles' (array), Form uses 'title' (string)
  if (aiResult.titles && aiResult.titles.length > 0) {
    hydratedData['title'] = aiResult.titles[0];
  }
  
  // AI uses 'priceSuggested', Form uses 'price'
  if (aiResult.priceSuggested) {
    hydratedData['price'] = aiResult.priceSuggested;
  }

  // AI uses 'description', Form uses 'description'
  if (aiResult.description) {
    hydratedData['description'] = aiResult.description;
  }

  const mainCat = CATEGORIES_DATA.find(c => c.id === categoryId);
  const subCatName = mainCat.subCategories?.find(s => s.id === subCategoryId);



  // 2. Map Category-Specific Fields Dynamically
  // We look at the specs for the detected category
  const specFields =  CATEGORY_FORM_SPECS[subCatName?.name] || CATEGORY_FORM_SPECS[categoryId] || [];
  
  specFields.forEach(spec => {
    // If the AI result contains a key matching the spec name, grab it
    if (aiResult[spec.name] !== undefined && aiResult[spec.name] !== null) {
      hydratedData[spec.name] = aiResult[spec.name];
    }
  });

  return hydratedData;
};